export const app = {
  name: 'La Bibli',
};

export const firebase = {
  apiKey: 'AIzaSyBlGRukL_UIhnHw7V75n8ClUYD6eSKOrVA',
  authDomain: 'biblio-44466.firebaseapp.com',
  databaseURL: 'https://biblio-44466.firebaseio.com',
  projectId: 'biblio-44466',
  storageBucket: 'biblio-44466.appspot.com',
  messagingSenderId: '771439924140',
  appId: '1:771439924140:web:47e98940edcd474f27a009',

};

export const reduxFirebase = {
  userProfile: 'users',
  useFirestoreForProfile: true,
  enableLogging: false,
};

// GlitchTip, sur le serveur d'Aynils à Toronto — plus Sentry aux États-Unis.
// Compatible avec le SDK Sentry, donc seule cette valeur change : le front
// reste sur @sentry/browser.
//
// ⛔ Projet 4, pas le 2 : le front et l'API ont chacun LEUR projet, comme
// c'était déjà le cas chez Sentry. Les fusionner noierait les erreurs serveur
// sous le bruit des navigateurs et des extensions, qu'on ne contrôle pas — et
// on peut fusionner deux flux plus tard, on ne les resépare pas. ⚠️ Cette version-là date de 2020 (^5.18.1) ; si
// les événements du front n'arrivent plus alors que ceux de l'API arrivent,
// c'est le premier endroit à regarder, pas la configuration du serveur.
export const sentryUrl = 'https://72276eff99344de29befa4a9ae69d135@erreurs.aynils.tech/4';

export const LANGUAGES_LABELS = [
  { code: 'fr', text: 'Francais' },
  { code: 'en', text: 'English' },
];

export const stripe = {
  publicApiKEy: 'pk_live_51H39kMCpTgAka9PhYMIpM13f8rigwif8TVAf7FOQqGwagZV66rtGAHYo64jeP92on6DbAY4cUDyRGxMmeCdTlutr00l09aKoSJ',
};

/**
 * Le centre d'aide, ouvert depuis le menu.
 *
 * 🔴 CETTE ADRESSE EST PROVISOIRE. La documentation vivra sur
 * « https://labibli.com/docs/intro », mais `labibli.com` sert encore le Carrd :
 * y pointer aujourd'hui enverrait les bibliothécaires sur une page de vente
 * sans documentation, depuis un bouton nommé « Centre d'aide ».
 *
 * ⇒ À BASCULER le jour où le domaine pointe sur le nouveau site. C'est une
 * ligne, et elle est inscrite dans
 * `labibli-website/exploitation/avant-la-mise-en-ligne.md` pour ne pas être
 * oubliée — un lien d'aide qui mène ailleurs est pire qu'un lien absent.
 */
export const AIDE_URL = 'https://labibli-website-93hr7.ondigitalocean.app/docs/intro';
